module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lmNsj"))).then(() => parcelRequire('1iHdE'));